var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "background-color": "#ccc" },
      attrs: { id: "question-wrapper" },
    },
    [
      _vm._l(_vm.payload, function (question, index) {
        return _c("SingleQuestionEditor", {
          key: question.id,
          attrs: {
            "on-removed": _vm.onQuestionRemoved,
            "show-next-question-action": index !== _vm.payload.length - 1,
            startDrag: _vm.startDrag,
            onDrop: _vm.onDrop,
            index: index,
            payload: _vm.payload,
          },
          model: {
            value: _vm.payload[index],
            callback: function ($$v) {
              _vm.$set(_vm.payload, index, $$v)
            },
            expression: "payload[index]",
          },
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-single-question-wrapper filter-add-group-wrapper" },
        [
          _c("div", { staticClass: "add-single-question" }, [
            _c(
              "div",
              {
                staticClass: "add-single-question-plus",
                on: { click: _vm.addNewQuestion },
              },
              [_c("span", { staticClass: "material-icons" }, [_vm._v(" add ")])]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.addNextQuestion"))),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }